import { useMutation } from '@tanstack/react-query';

import { MutationOptions } from 'src/utils/libs/reactQuery';
import { tenantService } from '../tenant.service';

const useDeleteTenant = (options?: MutationOptions<number>) => {
  return useMutation({
    mutationFn: tenantService.delete,
    ...options,
  });
};

export default useDeleteTenant;
